import {
  DrawSchema,
  SetWinnerSchema,
  type DrawResult,
} from '@pin/schemas/admin';
import { firstValueFrom } from 'rxjs';
import { fromFetch } from 'rxjs/fetch';
import { timeout } from 'rxjs/operators';
import { withIdToken } from '../firebase/auth';
import { adminApiUrl } from '../utils/context';
import { HttpError } from '../utils/rxjs.http';

export const getExistingDraw = (
  participantId: string
): Promise<DrawResult | null> =>
  firstValueFrom(
    withIdToken((token) =>
      fromFetch(
        `${adminApiUrl}/api/results/participant/${participantId}/candidates`,
        {
          method: 'GET',
          headers: { Authorization: `Bearer ${token}` },
          selector: async (res) => {
            if (res.status === 404) return null;
            if (!res.ok) throw new HttpError(res);
            return DrawSchema.parse(await res.json());
          },
        }
      ).pipe(timeout(10_000))
    )
  );

export const drawCandidates = (participantId: string): Promise<DrawResult> => {
  const path = `/api/results/participant/${participantId}/draw`;
  const query = import.meta.env.DEV ? '?includeTestUsers=true' : '';
  return firstValueFrom(
    withIdToken((token) =>
      fromFetch(`${adminApiUrl}${path}${query}`, {
        method: 'POST',
        headers: { Authorization: `Bearer ${token}` },
        selector: async (res) => {
          // 404 means no eligible candidates - return empty entries
          if (res.status === 404) return { entries: [] };
          if (!res.ok) throw new HttpError(res);
          return DrawSchema.parse(await res.json());
        },
      }).pipe(timeout(10_000))
    )
  );
};

export const setWinner = (
  drawId: string,
  userId: string
): Promise<DrawResult> =>
  firstValueFrom(
    withIdToken((token) =>
      fromFetch(`${adminApiUrl}/api/results/draw/${drawId}/winner`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(SetWinnerSchema.parse({ userId })),
        selector: async (res) => {
          if (!res.ok) throw new HttpError(res);
          return DrawSchema.parse(await res.json());
        },
      }).pipe(timeout(10_000))
    )
  );
